import React, { useState } from 'react';
import propTypes from 'prop-types';
import { Dropdown } from '@tcc/crate';

function sortByName(a, b) {
  const productA = a.name.toUpperCase();
  const productB = b.name.toUpperCase();

  let comparison = 0;
  if (productA > productB) {
    comparison = 1;
  } else if (productA < productB) {
    comparison = -1;
  }
  return comparison;
}

const ApplicationProtectionDropdown = ({
  disabled,
  onSetValue,
  products,
  selectedProduct
}) => {
  const [filter, setFilter] = useState('');
  const sortedProducts = products
  .sort(sortByName)
  .filter(p => p.name.trim().toLowerCase().includes(filter));

  return (
    <React.Fragment className="application-protection-dropdown">
      <Dropdown
        disabled={disabled}
        onSearchFilter={setFilter}
        options={sortedProducts}
        searchable
        selectedId={selectedProduct.id}
        setValue={(val, id) => onSetValue(val, id)}
      />
    </React.Fragment>
  );
};

ApplicationProtectionDropdown.propTypes = {
  disabled: propTypes.bool,
  onSetValue: propTypes.func,
  products: propTypes.array,
  selectedProduct: propTypes.object
};

export default ApplicationProtectionDropdown;
